/**
 * Receipt Teaser front-end behaviour.
 *
 * The block is visual only at this stage (founder decision 2026-09-16): the
 * submit button is `disabled` in render.php and nothing here submits, validates
 * or navigates. The one runtime behaviour the React component has that is
 * purely presentational is the chroma sweep on the heading accent, so that is
 * all this file does — same contract as the Product Value block.
 */

function initChromaReveal( el ) {
	const observer = new window.IntersectionObserver(
		( entries ) => {
			for ( const entry of entries ) {
				if ( entry.isIntersecting ) {
					// Swap, don't stack: the reference
					// (src/ui/chroma-reveal.tsx) drops the colour class
					// when it adds the gradient ones. Keeping
					// `text-dark-text-10` alongside them leaves a colour
					// utility — layer(utilities), so it outranks the
					// layer(components) `.chroma-text` — painting the
					// accent solid instead of transparent.
					el.classList.remove( 'text-dark-text-10' );
					el.classList.add( 'chroma-text', 'chroma-sweep-animate' );
					observer.disconnect();
					break;
				}
			}
		},
		{ threshold: 0.4 }
	);
	observer.observe( el );
}

document.addEventListener( 'DOMContentLoaded', () => {
	document
		.querySelectorAll(
			'.wp-block-avoid-content-receipt-teaser .chroma-reveal-accent'
		)
		.forEach( initChromaReveal );
} );
